module.exports = __webpack_public_path__ + "img/facebook-Icon.b0f8b98d.svg";